export default "__VITE_ASSET__DaBEuo0X__"